import React from "react";
import { Container, Paper } from "@mantine/core";

const PrivacyPage = () => {
  return (
    <Container size="md">
      <Paper padding="lg">
        <h1 style={{ textAlign: "center" }}>Privacy Policy</h1>
        <p>
          At Data4Research, we are committed to protecting your privacy and
          ensuring the security of your data. This Privacy Policy outlines how
          we collect, use, and protect the information you provide to us as part
          of the data-donation process. By using our service and participating
          in our research, you agree to the terms of this Privacy Policy.
        </p>

        <h3>Data Collection</h3>
        <p>
          As part of our research project, we collect YouTube watch history and
          Chrome browsing history data through Google Takeout. This data
          includes information about the videos you watch on YouTube and the
          websites you visit using the Chrome browser.
        </p>

        <h3>Data Anonymization</h3>
        <p>
          We take your privacy seriously, and your data will be anonymized
          before analysis. Any personally identifiable information, such as your
          name, email address, or IP address, will be removed from the dataset.
          This ensures that your data remains completely confidential and cannot
          be linked back to you individually.
        </p>

        <h3>Data Usage</h3>
        <p>
          The data you provide will only be used for research purposes within
          the scope of our project. It will be used to analyze trends,
          preferences, and user interactions within YouTube and Chrome
          platforms. The insights gained from this research will be used to
          improve content creation, user interface design, and personalized
          recommendations, aiming to enhance the online experience for all
          users.
        </p>

        <h3>Data Security</h3>
        <p>
          We take all necessary precautions to ensure the security and integrity
          of your data. The data will be securely stored in a protected
          environment accessible only to authorized researchers. We have
          implemented technical and organizational measures to prevent
          unauthorized access, use, or disclosure of your data.
        </p>

        <h3>Data Sharing</h3>
        <p>
          The anonymized data collected from you may be shared with other
          researchers, institutions, or organizations for scientific and
          academic purposes. However, all data sharing will be done in a manner
          that preserves your anonymity. Any published results or reports will
          only include aggregated data and will not include any information that
          could identify individual participants.
        </p>

        <h3>Voluntary Participation</h3>
        <p>
          Your participation in the data-donation process is entirely voluntary.
          You have the right to withdraw your consent at any time without any
          negative consequences. If you decide to withdraw, any data collected
          up to that point will be retained, but no further data will be
          collected from you.
        </p>

        <h3>Children's Privacy</h3>
        <p>
          Our data-donation service is intended for individuals above the age of
          18. We do not knowingly collect personal information from individuals
          under the age of 18. If you are a parent or guardian and believe that
          your child has provided their data without your consent, please
          contact us immediately, and we will promptly remove the information.
        </p>

        <h3>Contact Information</h3>
        <p>
          If you have any questions or concerns regarding this Privacy Policy or
          our data-donation process, please feel free to contact us at [contact
          email/phone number]. We are here to provide any additional information
          you may need and address any concerns you may have.
        </p>
      </Paper>
    </Container>
  );
};

export default PrivacyPage;
